export const useUser = () => {
  const dbLocalStorage = localStorage.getItem('authentication')

  const user = JSON.parse(dbLocalStorage)

  return { ...user }
}
